/**
 * Component Registry for Traders Row
 * 
 * Inherits from @vibesites-dolben/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-dolben/theme-rise/registry';
import { IncomeRestrictedContent } from './components/IncomeRestrictedContent';
import { TradersWorksContent } from './components/TradersWorksContent';
import { Header } from './components/Header';
import { SitemapContent } from './components/SitemapContent';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  IncomeRestrictedContent,
  TradersWorksContent,
  Header,
  SitemapContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
